<template>
  <div class="card-pan">
    <v-field
      :name="name"
      type="text"
      class="payredirect-line-1-num-item"
      @click="$event.target.select()"
      maxlength="23"
      placeholder="0000 0000 0000 0000"
      pattern="[0-9]*"
      inputmode="numeric"
      v-model="pan"
      @keypress="isNumber"
    />
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { Field as VField } from 'vee-validate'
import { onMounted, ref, watch } from 'vue'

const model = defineModel()
const { t } = useI18n()

const props = defineProps({
  name: String,
})

const pan = ref(model.value)

const setValue = value => {
  let realNumber = value.replace(/\s/gi, '')
  model.value = realNumber
  let dashedNumber = realNumber.match(/.{1,4}/g) || []
  pan.value = dashedNumber.join(' ')
}

watch(pan, (value, prevValue) => {
  if (prevValue !== value) {
    setValue(value)
  }
})

watch(model, (value, prevValue) => {
  if (prevValue !== value) {
    setValue(value)
  }
})

onMounted(() => {
  setValue(model.value)
})

const isNumber = evt => {
  const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
  const keyPressed = evt.key

  if (!keysAllowed.includes(keyPressed)) {
    evt.preventDefault()
  }
}
</script>

<style scoped></style>
